import geovistoryDesignSystemWebGlobalScript from '/app/node_modules/@geovistory/design-system-web/dist/_build.global.js';
import ionicCoreGlobalScript from '/app/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import appGlobalScript from '/app/src/global/app.ts';
export const globalScripts = () => {
  appGlobalScript();
  ionicCoreGlobalScript();
  geovistoryDesignSystemWebGlobalScript();
};
